import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

/** CLOUDWEB-18349: Фича включения оплаты через мидас в TariffBuy на вебе */
export const dmrMidasBuyWeb: boolean = isFeature('dmr-midas-buy');
/** CLOUDWEB-18349: Фича включения оплаты через мидас в TariffBuy на таче */
export const dmrMidasBuyTouch: boolean = isFeature('dmr-midas-buy-touch');
export const dmrMidasBuyEnabled: boolean = IS_MOBILE_BROWSER ? dmrMidasBuyTouch : dmrMidasBuyWeb;

/** CLOUDWEB-19295: Фича включения оплаты через мидас в TariffBuy для триалов на таче */
export const dmrMidasTrialTouch = isFeature('dmr-midas-trial-touch');

/** CLOUDWEB-19295: Фича включения оплаты через мидас в окне оплаты с сайдбаром(VkBuyModalWithSidebar) */
export const dmrMidasFastcheckout = isFeature('dmr-midas-fastcheckout');

/** CLOUDWEB-19846: Фича включения оплаты триала через мидас в окне оплаты с сайдбаром(VkBuyModalWithSidebar) */
export const dmrMidasFastcheckoutTrial = isFeature('dmr-midas-trial');

/** CLOUDWEB-19848: Фича включения оплаты скидочного тарифа через мидас в окне оплаты с сайдбаром(VkBuyModalWithSidebar) */
export const dmrMidasFastcheckoutDiscount = isFeature('dmr-midas-discount');

export const dmrMidasBuyFrame: boolean = isFeature('dmr-midas-buy-frame');
export const dmrMidasBuyFrameWithSidebar: boolean = isFeature('dmr-midas-buy-frame-sidebar');
export const dmrMidasBuyFrameCarousel: boolean = isFeature('dmr-midas-buy-frame-carousel');

if (dmrMidasBuyEnabled) {
    registerExperiment('midas-buy', dmrMidasBuyEnabled, [
        AnalyticEventNames.TARIFF_CLICK,
        AnalyticEventNames.FAST_CHECKOUT_SHOWN,
        AnalyticEventNames.TARIFF_BUY,
    ]);
}

registerExperiment(
    'midas-trial',
    dmrMidasFastcheckoutTrial ? 'b' : 'a',
    [AnalyticEventNames.BUY_FAST_CHECKOUT_VIEW, AnalyticEventNames.BUY_FAST_CHECKOUT_CLICK_PAY],
    {
        mapEventNames: {
            BUY_FAST_CHECKOUT_CLICK_PAY: 'click',
            BUY_FAST_CHECKOUT_VIEW: 'checkout',
        },
        sendXrayArgs: {
            BUY_FAST_CHECKOUT_CLICK_PAY: ({ product, isFrame }) => ({ cancel: isFrame || !product?.hasTrial }),
            BUY_FAST_CHECKOUT_VIEW: ({ product, isFrame }) => ({ cancel: isFrame || !product?.hasTrial }),
        },
    }
);

registerExperiment(
    'midas-discount',
    dmrMidasFastcheckoutDiscount ? 'b' : 'a',
    [AnalyticEventNames.BUY_FAST_CHECKOUT_VIEW, AnalyticEventNames.BUY_FAST_CHECKOUT_CLICK_PAY],
    {
        mapEventNames: {
            BUY_FAST_CHECKOUT_CLICK_PAY: 'click',
            BUY_FAST_CHECKOUT_VIEW: 'checkout',
        },
        sendXrayArgs: {
            BUY_FAST_CHECKOUT_CLICK_PAY: ({ product, isFrame }) => ({ cancel: isFrame || !(!product?.hasTrial && product.hasDiscount) }),
            BUY_FAST_CHECKOUT_VIEW: ({ product, isFrame }) => ({ cancel: isFrame || !(!product?.hasTrial && product.hasDiscount) }),
        },
    }
);

registerExperiment(
    'midas-buy-carousel',
    dmrMidasBuyFrameCarousel ? 'b' : 'a',
    [AnalyticEventNames.BUY_FAST_CHECKOUT_VIEW, AnalyticEventNames.BUY_FAST_CHECKOUT_CLICK_PAY],
    {
        mapEventNames: {
            BUY_FAST_CHECKOUT_CLICK_PAY: 'click',
            BUY_FAST_CHECKOUT_VIEW: 'checkout',
        },
        sendXrayArgs: {
            BUY_FAST_CHECKOUT_CLICK_PAY: ({ isCarouselFrame }) => ({ cancel: !isCarouselFrame }),
            BUY_FAST_CHECKOUT_VIEW: ({ isCarouselFrame }) => ({ cancel: !isCarouselFrame }),
        },
    }
);

registerExperiment(
    'midas-buy-sidebar',
    dmrMidasBuyFrame ? 'b' : 'a',
    [AnalyticEventNames.BUY_FAST_CHECKOUT_VIEW, AnalyticEventNames.BUY_FAST_CHECKOUT_CLICK_PAY],
    {
        mapEventNames: {
            BUY_FAST_CHECKOUT_CLICK_PAY: 'click',
            BUY_FAST_CHECKOUT_VIEW: 'checkout',
        },
        sendXrayArgs: {
            BUY_FAST_CHECKOUT_CLICK_PAY: ({ isCarouselFrame, withoutSidebar, isFrame }) => ({
                cancel: isCarouselFrame || withoutSidebar || !isFrame,
            }),
            BUY_FAST_CHECKOUT_VIEW: ({ isCarouselFrame, withoutSidebar, isFrame }) => ({
                cancel: isCarouselFrame || withoutSidebar || !isFrame,
            }),
        },
    }
);

registerExperiment(
    'midas-buy-frame',
    dmrMidasBuyFrameWithSidebar ? 'b' : 'a',
    [AnalyticEventNames.BUY_FAST_CHECKOUT_VIEW, AnalyticEventNames.BUY_FAST_CHECKOUT_CLICK_PAY],
    {
        mapEventNames: {
            BUY_FAST_CHECKOUT_CLICK_PAY: 'click',
            BUY_FAST_CHECKOUT_VIEW: 'checkout',
        },
        sendXrayArgs: {
            BUY_FAST_CHECKOUT_CLICK_PAY: ({ isCarouselFrame, withoutSidebar, isFrame }) => ({
                cancel: isCarouselFrame || !withoutSidebar || !isFrame,
            }),
            BUY_FAST_CHECKOUT_VIEW: ({ isCarouselFrame, withoutSidebar, isFrame }) => ({
                cancel: isCarouselFrame || !withoutSidebar || !isFrame,
            }),
        },
    }
);
